// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VModal from 'vue-js-modal'
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueClipboard from 'vue-clipboard2'
import store from './store'
import { signup } from './lib/api/calls.js'
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css');

Vue.use(VueTour);

require('./components')
require('./helpers')
//require('./../../parkave-integration/src/lib/parkave')

Vue.use(VModal)

const snotifyOptions = {
  toast: {
    position: SnotifyPosition.rightTop,
  }
}

Vue.use(Snotify, snotifyOptions)
Vue.use(VueClipboard)

Vue.config.productionTip = false

store.dispatch('loadConfig').then((config) => {
  console.log('Got config', config);
  window.parkave_config = config;
});

store.dispatch('loadMe').then((me) => {
  // helpscout
  if (me.confirmed == false) {
    let rootVM = window.rootVM;
    rootVM.$snotify.info('You email hasn\'t been confirmed! Click here to resend the welcome email.', {
      timeout: 4000,
      buttons: [
        {
          text: 'Close',
          bold: true
        },
        {
          text: 'Resend',
          bold: true,
          action: () => {
            signup(me.email, null, null).then((response) => {
              if (!response.error) {
                rootVM.$snotify.success('Email sent.');
              } else {
                rootVM.$snotify.error(response.error);
              }
            })
          }
        }
      ],
      showProgressBar: false,
      closeOnClick: true
    })
  }

  if (!me.id) return;
  store.dispatch('accounts/loadOwned').then((account) => {
    if (!account) return

    if (localStorage.parkave_partner_code && !account.referred_by_code) {
      let payload = {
        referred_by_code: localStorage.parkave_partner_code,
        id: account.id,
        skipSuccessMessage: true
      };
      store.dispatch('accounts/update', payload)
      localStorage.removeItem('parkave_partner_code')
    }
    if (account.plan.show_beacon_docs && window.innerWidth > 600) {
      window.Beacon('init', '4aa33787-aa7b-406f-89f8-b764dfd6ad3b');
    }
    let mode = 'neutral';
    let messagingEnabled = false;
    if (!account.plan.is_supported) {
      mode = 'selfService'
    } else if (account.plan.is_supported) {
      mode = 'askFirst';
      messagingEnabled = true
    }
    if (me.email && window.Beacon && window.innerWidth > 600) {
      window.Beacon("identify", {
        name: me.name,
        email: me.email,
        account: account.name,
        plan: account.plan.name
      });
      // This is an example script - don't forget to change it!
      FS.identify(me.id, {
        displayName: me.name,
        email: me.email,
        plan_name_str: account.plan.name,
        plan_id: account.plan.id,
        account_name_str: account.name,
        account_id: account.id
      });
      window.Beacon('config', {
        labels: {
          messageConfirmationText: 'You’ll receive an email reply shortly.'
        },
        messagingEnabled: messagingEnabled,
        color: '#ffffff', // Blue: 0051FF
        mode: mode
      });
    }

    if (account.has_selected_formats) {
      store.dispatch('formats/loadSelected');
    }
    store.dispatch('advertisements/load');
    store.dispatch('loadPreferences');
    store.dispatch('users/loadFavorites');
  })
});

store.dispatch('categories/load');
store.dispatch('formats/load');
store.dispatch('categories/formats/load');
store.dispatch('loadPlans');
store.dispatch('loadAdminDeMocker');

window.store = store;

Sentry.init({
  Vue,
  dsn: 'https://66d3f06722d04dd2baa091e1a4b7a389@o989201.ingest.sentry.io/5983300',
  // integrations: [
  //   new Integrations.BrowserTracing({
  //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
  //     tracingOrigins: ['localhost', 'app.getparkave.com', /^\//],
  //   }),
  // ],
  // // Set tracesSampleRate to 1.0 to capture 100%
  // // of transactions for performance monitoring.
  // // We recommend adjusting this value in production
  // tracesSampleRate: 1.0
});

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  store,
  router,
  template: '<App/>',
  components: { App },
  data: {
    ParkAve
  }
}).$mount('#app');

/*new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  data: {
    ParkAve
  }
})*/

import * as calls from './lib/api/calls'



// WEBPACK FOOTER //
// ./src/main.js